// A brand image for an <img>: its S3 link (saved as "url:https://...", like fund static-data images) or,
// for a brand not uploaded again since, its stored bytes as base64. See code-plan/api/plan-brandImagesS3.md.

/** An <img> src for a stored image value: "url:" + URL becomes the URL, anything else is base64 PNG. */
export function imageSrc(value) {
    if (!value) {
        return null;
    }
    return value.startsWith('url:') ? value.slice(4) : `data:image/png;base64, ${value}`;
}

/**
 * The editor footer's logo request: the document's brand_mapping brand's logo, else the master
 * brand's, chosen as the PDF chooses its mapping ticker: one fund, else the document's group, else
 * the funds (the server takes the offer or scheme they share).
 */
export function logoForPath(data) {
    const tickers = (data?.tickers || []).filter(t => t);
    const params = new URLSearchParams();
    if (data?.templateName) params.set('template', data.templateName);
    if (tickers.length === 1) {
        params.set('ticker', tickers[0]);
    } else if (data?.tickerGroup) {
        params.set('ticker', data.tickerGroup);
    } else if (tickers.length > 1) {
        params.set('tickers', tickers.join(','));
    }
    return `brand/logo-for?${params.toString()}`;
}

/** The brand image's src: the S3 link when it has one, else the bytes; null for neither. */
export function brandImageSrc(link, bytes) {
    return imageSrc(link) || imageSrc(bytes);
}
